import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Form, FormGroup } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import Blue_Round_Btn from "../../common-btn/blue_round_btn/Blue_Round_Btn";
import Red_Round_Btn from "../../common-btn/red_round_btn/Red_Round_Btn";
import "./New_Address_Modal.css";
import Success_Modal from "../success_modal/Success_Modal";
import { useDispatch, useSelector } from "react-redux";
import {
  AllCity,
  AllPincode,
  AllState,
  getAllCountries,
} from "../../../../features/master/masterSlice";
import {
  createUserAddress,
  updateUserAddress,
} from "../../../../features/user/userSlice";
import {
  deleteAddress,
  EditOrderAddress,
  getAllOrderAddress,
  getSingleOrderAddress,
} from "../../../../features/order/orderSlice";

const Edit_Address_Modal = ({Id, ...props }) => {
  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const countries1 = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllCountries());
  }, [dispatch]);

  const countries = useSelector((state) => state.master.all_country);
  const states = useSelector((state) => state.master.all_state);
  const cities = useSelector((state) => state.master.all_city);
  const pincodes = useSelector((state) => state.master.all_pincode);

  const onSubmit = async (data) => {
    const sendData = {
      address_type_id: data?.address_type_id,
      apartment: data?.apartment,
      building: data?.building,
      direction: data?.direction,
      contact_no: data?.contact_no,
      floor: data?.floor,
      street: data?.street,
      country_id: data?.country_id?.value,
      state_id: data?.state_id?.value,
      city_id: data?.city_id?.value,
      pincode_id: data?.pincode_id?.value,
    };

    const res = await dispatch(EditOrderAddress({ id: Id, data: sendData }));
    console.log(res, "res res");

    if (res.meta?.requestStatus === "fulfilled") {
      // props?.onHide();
      await dispatch(getAllOrderAddress());
      props?.onHide();
      reset();
      setSuccessmodal(true);
      setTimeout(() => {
        setSuccessmodal(false);
      }, 2000);
    } else if (res.meta?.requestStatus === "rejected") {
    }
  };

  const [successmodal, setSuccessmodal] = useState(false);

  const singleOrdersAddress = useSelector((state) => state.order.orderAddress);
  useEffect(() => {
    if (props.show && Id) {
      dispatch(getSingleOrderAddress({ id: Id }));
    }
  }, [dispatch, props.show, Id]);

  useEffect(() => {
    if (singleOrdersAddress) {
      reset(singleOrdersAddress);
    }
  }, [singleOrdersAddress, reset]);

  console.log(Id, "props?.Id props?.Id");

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="Reschedule_Appointment_Modal New_Address_Modal"
      >
        <Modal.Body>
          <div className="reschedule_form">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                <div className="col-sm-12">
                  <Form.Group className="input_group">
                    <Form.Label>Address Type</Form.Label>

                    <Controller
                      name="address_type_id"
                      control={control}
                      rules={{ required: "Please select address type" }}
                      render={({ field }) => (
                        <div className="radio_holder">
                          <Form.Check
                            type="radio"
                            label="Home"
                            id="radio-home"
                            name={field.name}
                            value="1"
                            onChange={field.onChange}
                            checked={field.value == "1"}
                          />
                          <Form.Check
                            type="radio"
                            label="Office"
                            id="radio-office"
                            name={field.name}
                            value="4"
                            onChange={field.onChange}
                            checked={field.value == "4"}
                          />
                          <Form.Check
                            type="radio"
                            label="Other"
                            id="radio-apartment"
                            name={field.name}
                            value="2"
                            onChange={field.onChange}
                            checked={field.value == "2"}
                          />
                        </div>
                      )}
                    />

                    {errors?.address_type_id && (
                      <sup className="text-danger">
                        {errors?.address_type_id?.message}
                      </sup>
                    )}
                  </Form.Group>
                </div>

                <div className="col-sm-6">
                  <Form.Group
                    className="input_group"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Receiver's Contact No</Form.Label>
                    <Form.Control
                      type="text"
                      maxLength={10}
                      placeholder="Enter Contact No"
                      {...register("contact_no", {
                        required: "Contact No is required",
                        pattern: {
                          value: /^[0-9]{10}$/,
                          message: "Enter valid 10-digit Contact No",
                        },
                      })}
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                    {errors?.contact_no && (
                      <sup className="text-danger">
                        {errors?.contact_no?.message}
                      </sup>
                    )}
                  </Form.Group>
                </div>

                <div className="col-sm-6">
                  <Form.Group
                    className="input_group"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Country / Region</Form.Label>
                    <Controller
                      className="Select_Dropdown_holder"
                      name="country_id" // Form field name
                      control={control}
                      rules={{ required: "Country is required" }}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.country_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={countries}
                          onChange={(selectedOption) => {
                            field.onChange(selectedOption);
                            dispatch(
                              AllState({ countryId: selectedOption.value })
                            );
                            dispatch(AllPincode({}));
                            dispatch(AllCity({}));
                            setValue("state_id", null);
                            setValue("city_id", null);
                            setValue("pincode_id", null);
                          }}
                        />
                      )}
                    />
                    {errors?.country_id && (
                      <sup className="text-danger">
                        {errors?.country_id?.message}
                      </sup>
                    )}
                  </Form.Group>
                </div>

                <div className="col-sm-6">
                  <Form.Group
                    className="input_group"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>State</Form.Label>
                    <Controller
                      className="Select_Dropdown_holder"
                      name="state_id" // Form field name
                      control={control}
                      rules={{ required: "State is required" }}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.state_id ? "red" : baseStyles,
                            }),
                          }}
                          {...field}
                          options={states}
                          onChange={(selectedOption) => {
                            field.onChange(selectedOption);
                            dispatch(
                              AllCity({ stateId: selectedOption.value })
                            );
                            dispatch(AllPincode({}));
                            setValue("city_id", null);
                            setValue("pincode_id", null);
                          }}
                        />
                      )}
                    />
                    {errors?.state_id && (
                      <sup className="text-danger">
                        {errors?.state_id?.message}
                      </sup>
                    )}
                  </Form.Group>
                </div>

                <div className="col-sm-6">
                  <Form.Group
                    className="input_group"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>City</Form.Label>
                    <Controller
                      className="Select_Dropdown_holder"
                      name="city_id" // Form field name
                      control={control}
                      rules={{ required: "City is required" }}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.city_id ? "red" : baseStyles,
                            }),
                          }}
                          {...field}
                          options={cities}
                          onChange={(selectedOption) => {
                            field.onChange(selectedOption);
                            dispatch(
                              AllPincode({ cityId: selectedOption.value })
                            );
                            setValue("pincode_id", null);
                          }}
                        />
                      )}
                    />
                    {errors?.city_id && (
                      <sup className="text-danger">
                        {errors?.city_id?.message}
                      </sup>
                    )}
                  </Form.Group>
                </div>

                <div className="col-sm-6">
                  <Form.Group
                    className="input_group"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Pincode</Form.Label>
                    <Controller
                      className="Select_Dropdown_holder"
                      name="pincode_id" // Form field name
                      control={control}
                      rules={{ required: "Pincode is required" }}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.pincode_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={pincodes}
                        />
                      )}
                    />
                    {errors?.pincode_id && (
                      <sup className="text-danger">
                        {errors?.pincode_id?.message}
                      </sup>
                    )}
                  </Form.Group>
                </div>
                {/* <div className="col-sm-6">
                  <Form.Group
                    className="input_group"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Area</Form.Label>
                    <Controller
                      className="Select_Dropdown_holder"
                      name="area_id" // Form field name
                      control={control}
                      rules={{ required: "Area is required" }}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.area_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={countries}
                        />
                      )}
                    />
                    {errors?.area_id && (
                      <sup className="text-danger">
                        {errors?.pincode_id?.message}
                      </sup>
                    )}
                  </Form.Group>
                </div> */}

                <div className="col-sm-12">
                  <Form.Group
                    className="input_group"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Flat, House No., Apartment</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Flat, House No., Apartment no."
                      {...register("apartment", {
                        required: "Apartment No. is required",
                      })}
                    />
                    {errors?.apartment && (
                      <sup className="text-danger">
                        {errors?.apartment?.message}
                      </sup>
                    )}
                  </Form.Group>

                  <Form.Group
                    className="input_group"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Building</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Building, Company, Apartment"
                      {...register("building", {
                        required: "Building,Company, ApartmentName is required",
                      })}
                    />
                    {errors?.building && (
                      <sup className="text-danger">
                        {errors?.building?.message}
                      </sup>
                    )}
                  </Form.Group>
                </div>

                <div className=" col-sm-12">
                  <Form.Group
                    className="input_group"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Floor</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Floor No, "
                      {...register("floor", {
                        required: "Floor No is required",
                      })}
                    />
                    {errors?.floor && (
                      <sup className="text-danger">
                        {errors?.floor?.message}
                      </sup>
                    )}
                  </Form.Group>
                </div>

                <div className="col-sm-12">
                  <Form.Group
                    className="input_group"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Area, Street, Sector, Village</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Area, Street, Sector, Village"
                      {...register("street", {
                        required: "Area, Street, Sector, Village is required",
                      })}
                    />
                    {errors?.street && (
                      <sup className="text-danger">
                        {errors?.street?.message}
                      </sup>
                    )}
                  </Form.Group>
                </div>

                <div className="col-sm-12">
                  <Form.Group
                    className="input_group"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Landmark</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Landmark"
                      {...register("direction", {
                        required: "Landmark is required",
                      })}
                    />
                    {errors?.direction && (
                      <sup className="text-danger">
                        {errors?.direction?.message}
                      </sup>
                    )}
                  </Form.Group>
                </div>
              </div>

              <div className="btn_holder">
                <Blue_Round_Btn
                  btnText="Save"
                  type="submit"
                  onClick={() => {}}
                />
                <Red_Round_Btn
                  btnText={"Close"}
                  onClick={() => {
                    props?.onHide();
                  }}
                />
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>

      <Success_Modal
        show={successmodal}
        onHide={() => setSuccessmodal(false)}
        successText={"Address Edit Successfully !"}
      />
    </>
  );
};

export default Edit_Address_Modal;
